import type { ThemeOption } from "@/constants";

function getCurrentTheme(theme: ThemeOption) {
  if (theme === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  } else {
    return theme;
  }
}

function getValidTheme(str?: string) {
  return isValidTheme(str) ? str : "system";
}

function isValidTheme(str?: string): str is "dark" | "light" | "system" {
  return str === "dark" || str === "light" || str === "system";
}

export { getCurrentTheme, getValidTheme, isValidTheme };
